/* eslint-disable class-methods-use-this */
/* eslint-disable quotes */
/* eslint-disable max-statements */
/* eslint-disable indent */
/* eslint-disable max-lines-per-function */
import SliderFlexible from "./components/SliderFlexible";
import VideoFlexible from "./components/VideoFlexible";
import PointsDeVente from "./components/PointsDeVente";
import GrilleTarifs from "./components/GrilleTarifs";
import DocumentsATelechargerAccordion from "./components/DocumentsATelechargerAccordion";

export default class Base {
  constructor(id, section) {
    console.log(":: BASE ::");
    this.section = section;
    this.init(id, section);

    this.menuWrapper = document.querySelector(".mobile_menus");
    this.panel2 = document.querySelector(".panel:nth-child(2)");
    this.panel3 = document.querySelector(".panel:nth-child(3)");
    this.subMenuWrapper2 = this.panel2.querySelector(".sub-menu-wrapper");
    this.subMenuWrapper3 = this.panel3.querySelector(".sub-menu-wrapper");
    this.backOneLevelBtns = document.querySelectorAll(".back-one-level");
    this.isVisibleClass = "is-visible";
    this.toggleMenu = document.querySelector(".burger");
    this.archivesContainers = document.querySelectorAll(".archives-container");


    const ticker = document.querySelector(".topBanner");
    const btnCloseTicker = document.querySelector(".btnClose-ticker");

    var tableContainer = document.querySelectorAll(".tableContainer");
    if (tableContainer) {
      for (let i = 0; i < tableContainer.length; i++) {
        tableContainer[i].addEventListener("scroll", () => {
          document.querySelectorAll(".table-overlay")[i].style.display = "none";
        });

        tableContainer[i].addEventListener("click", () => {
          document.querySelectorAll(".table-overlay")[i].style.display = "none";
        });
      }
    }

    if (btnCloseTicker) {
      btnCloseTicker.addEventListener("click", (e) => {
        this.closeTicker(ticker);
      });
      btnCloseTicker.addEventListener("keyup", (e) => {
        if (e.key == "Enter") {
          this.closeTicker(ticker);
        }
      });
    }

    // Slider
    this.sectionSlider = document.querySelectorAll(".section-slider");
    if (this.sectionSlider.length > 0) {
      this.initSliders();
    }

    // Video
    this.sectionVideo = document.querySelectorAll(".section-video");
    if (this.sectionVideo.length > 0) {
      this.initVideos();
    }

    // Grilles
    this.sectionGrilles = document.querySelectorAll(".grille-tarifs");
    if (this.sectionGrilles.length > 0) {
      this.initGrilleTarifs();
    }


    this.documentsATelecharger = document.querySelectorAll(".documents-a-telecharger");
    if (this.documentsATelecharger.length > 0) {
      new DocumentsATelechargerAccordion();
    }

   

    // Points de Vente
    this.sectionPdv = document.querySelector(".section-pdv");
    if (this.sectionPdv) {
      this.pdv = new PointsDeVente();
    }

    if(this.archivesContainers){
      this.setTitleSizes();
      window.addEventListener("resize", this.setTitleSizes);
    }

    this.initLegacyCode();
    this.initMobileMenu();
    this.initNavLinksTracking();
    this.initTracking();
    this.initScrollTracking();
  }

  setTitleSizes(){
    this.archivesContainers = document.querySelectorAll(".archives-container");
    for(const container of this.archivesContainers){
      if(window.innerWidth > 991){
        const titres = container.querySelectorAll('.titre');
  
        // Initialize max height as 0
        let maxHeight = 0;
  
        // Loop through each element
        titres.forEach((titre) => {
          // Get the height of the current element
          titre.style.height = ``;
          const height = titre.scrollHeight;
          
          // Update max height if current height is greater
          if (height > maxHeight) {
            maxHeight = height;
          }
        });
  
        // Set the max height to all elements
        titres.forEach((titre) => {
          titre.style.height = `${maxHeight}px`;
        });
      }
      else if (window.innerWidth > 640 && window.innerWidth <= 991) {
        const rows = [];
        let currentRow = [];
        const items = container.querySelectorAll('.archive');
      
        for (let i = 0; i < items.length; i ++) {
          currentRow.push(items[i]);
      
          const nextItem = items[i + 1];
      
          if (!nextItem || (i + 1) % 2 === 0) {
            rows.push(currentRow);
            currentRow = [];
          }
        }
      
        if (currentRow.length > 0) {
          rows.push(currentRow);
        }
      
        rows.forEach((row) => {
          const titres = row.map((item) => item.querySelector('.titre'));
          titres.forEach((titre) => {
            titre.style.height = ``;
          });
        
          const maxHeight = Math.max(...titres.map((titre) => titre.offsetHeight));
      
          titres.forEach((titre) => {
            titre.style.height = `${maxHeight}px`;
          });
        });
      }  
      else {
        const titres = container.querySelectorAll('.titre');
  
        titres.forEach((titre) => {
          titre.style.height = ``;
        });
    }
    }    
  }

  initNavLinksTracking() {
    let links = document.querySelectorAll(".nav-link");
    this.setNavLinksListeners(links);
  }

  setNavLinksListeners(links) {
    Array.from(links).map((link) => {
      link.addEventListener("click", () => {
        var a = link;
        var els = [];
        let menu_item_parent = "";
        let click_url = link.href;
        let click_text = link.innerText.trim();
        let menuType = "";
        let menu_style = "";
        let nav_type = "";
        let listparent = [];
        let listLiparent = [];
        while (a) {
          els.unshift(a);
          a = a.parentNode;
          if (a != null && a.tagName == "LI") {
            listparent.push(a.childNodes[0].innerHTML);
          }
          if (a != null && a.tagName == "UL") {
            listLiparent.push(a.classList);
          }
        }
        listparent = listparent.reverse();
        for (let i = 0; i < listparent.length - 1; i++) {
          menu_item_parent += listparent[i].replace(
            '<i class="dashicons dashicons-external"></i>',
            ""
          );
          if (i != listparent.length - 1) {
            menu_item_parent += " > ";
          }
        }
        els.map((value) => {
          if (value.tagName == "UL") {
            if (value.id != "") {
              nav_type = value.id;
              menuType = value.classList[0];
            } else if (value.classList != null) {
            }
          }
        });

        // If mobile
        if (menu_item_parent == "") {
          menu_item_parent =
            link?.parentNode?.parentNode?.parentNode?.parentNode?.querySelector(
              ".back-one-level"
            )?.innerHTML;
        }
        if (menuType == "") {
          menuType = "menu";
        }
        if (nav_type == "") {
          nav_type = "mobile_menus__principal";
        }

        const panels =
          link?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.querySelectorAll(
            ".panel.is-visible"
          );
        if (Array.from(panels).length > 1) {
          menu_item_parent =
            panels[0]?.querySelector(".back-one-level")?.innerHTML +
            " > " +
            menu_item_parent;
        }

        if (Array.from(panels).length == 0) {
          menu_item_parent = "";
        }

        menu_style = listLiparent[0][0];
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "menu",
          click_url: click_url,
          click_text: click_text.replace(
            '<i class="dashicons dashicons-external"></i>',
            ""
          ),
          menu_item_parent: menu_item_parent, // i.e: nom du parent  de l'élément cliqué si non pertinent - élément cliqué est parent mettre 'self' - concatenation avec '>' comme séparateur
          menu_type: menuType,
          menu_style: menu_style,
          nav_type: nav_type, // valeurs issues du cms i.e nav secondaire, footer etc.?
        });
      });
    });
  }

  closeTicker(ticker) {
    ticker.classList.add("closed");
    let tickerHeight = ticker.clientHeight;
    ticker.style.marginTop = `-${tickerHeight}px`;
  }

  onResizePage() {
    if (window.matchMedia("(max-width: 991px)").matches) {
      this.initMobileMenu();
    }
    if(this.archivesContainers){
      for(const item of this.archivesContainers){
        const titres = item.querySelectorAll('.titre');

        // Initialize max height as 0
        let maxHeight = 0;

        // Loop through each element
        titres.forEach((titre) => {
          // Get the height of the current element
          const height = titre.offsetHeight;
          
          // Update max height if current height is greater
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        // Set the max height to all elements
        titres.forEach((titre) => {
          titre.style.height = `${maxHeight}px`;
        });
      }
    }
  }

  initMobileMenu() {
    // Add arrow after link in all li.menu-item-has-children
    const liHasChildren = document.querySelectorAll(
      ".mobile_menus__principal > .menu-item-has-children"
    );
    for (const li of liHasChildren) {
      const sectionName = li.querySelector("a").innerHTML;
      li.innerHTML += `<span class="chevron" data-name="${sectionName}"></span>`;
    }
    // The links are the chevron, not the text.
    const level1Links = document.querySelectorAll(
      ".mobile_menus__principal > .menu-item-has-children .chevron"
    );
    // In the event of a link with an empty href, the text will open the next panel too.
    const emptyLevel1Links = document.querySelectorAll(
      '.mobile_menus__principal > .menu-item-has-children a[href="#"]'
    );

    this.toggleMenu.addEventListener("click", (e) => {
      document.body.classList.toggle("fixed");
      e.currentTarget.classList.toggle("open");
      this.menuWrapper.classList.toggle(this.isVisibleClass);
      if (!e.currentTarget.classList.contains(this.isVisibleClass)) {
        // When closing the menu, remove the is-visible class from the second and third panels if they have it.
        this.panel2.classList.remove(this.isVisibleClass);
        this.panel3.classList.remove(this.isVisibleClass);
      }
    });

    for (const level1Link of level1Links) {
      level1Link.addEventListener("click", (e) => {
        // Click on a menu link of the first level (the visible ones)
        const siblingList = level1Link.previousElementSibling;

        // Check to see if it has a nested menu as a sibling.
        if (siblingList) {
          const linkName = level1Link.dataset.name;
          // console.log(level1Link);
          // console.log(linkName);
          this.clickLevel1(e, siblingList, linkName);
        }
      });
    }
    for (const emptyLevel1Link of emptyLevel1Links) {
      emptyLevel1Link.addEventListener("click", (e) => {
        // Click on a menu link of the first level (the visible ones)
        const siblingList = emptyLevel1Link.nextElementSibling;

        // Check to see if it has a nested menu as a sibling.
        if (siblingList) {
          const linkName = e.currentTarget.innerText;
          this.clickLevel1(e, siblingList, linkName);
        }
      });
    }

    for (const backOneLevelBtn of this.backOneLevelBtns) {
      backOneLevelBtn.addEventListener("click", (e) => {
        // Find the parent panel of the target back button and remove its is-visible class.
        const parent = e.currentTarget.closest(".panel");
        parent.classList.remove(this.isVisibleClass);
      });
    }
  }

  clickLevel1(e, siblingList, linkName) {
    e.preventDefault();
    // Text of clicked link as the Back button
    this.panel2.querySelector(".back-one-level").innerText = linkName;
    // Create a deep copy of its sibling.
    const cloneSiblingList = siblingList.cloneNode(true);
    // Append newly created node into the .sub-menu-wrapper of the second panel.
    this.subMenuWrapper2.innerHTML = "";
    this.subMenuWrapper2.append(cloneSiblingList);
    // Reveal the second panel with slide animation.
    this.panel2.classList.add(this.isVisibleClass);
    setTimeout(() => {
      const cloneSiblingListNavLinks =
        this.subMenuWrapper2.querySelectorAll(".nav-link");
      this.setNavLinksListeners(cloneSiblingListNavLinks);
    }, 500);

    this.initPanel2();
  }

  initPanel2() {
    // Same code as Level 1
    const liHasChildren = this.panel2.querySelectorAll(
      ".menu-item-has-children"
    );
    for (const li of liHasChildren) {
      const sectionName = li.querySelector("a").innerText;
      li.innerHTML += `<span class="chevron" data-name="${sectionName}"></span>`;
    }
    const level2Links = this.panel2.querySelectorAll(
      ".menu-item-has-children .chevron"
    );

    for (const level2Link of level2Links) {
      level2Link.addEventListener("click", (e) => {
        const siblingList = level2Link.previousElementSibling;
        if (siblingList) {
          e.preventDefault();
          this.panel3.querySelector(".back-one-level").innerText =
            level2Link.dataset.name;
          const cloneSiblingList = siblingList.cloneNode(true);
          this.subMenuWrapper3.innerHTML = "";
          this.subMenuWrapper3.append(cloneSiblingList);
          this.panel3.classList.add(this.isVisibleClass);
          setTimeout(() => {
            const cloneSiblingListNavLinks =
              this.subMenuWrapper3.querySelectorAll(".nav-link");
            this.setNavLinksListeners(cloneSiblingListNavLinks);
          }, 500);
        }
      });
    }
  }

  initLegacyCode() {
    // This is not Swoo code
    $(document).ready(() => {
      const videoIframes = [];
      const iframes = document.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        const src = iframe.src.toLowerCase();
        if (
          src.includes("youtube.com") ||
          src.includes("youtu.be") ||
          src.includes("vimeo.com") ||
          src.includes("/maps")
        ) {
          // console.log(iframe, "is youtube, vimeo or google maps");
          videoIframes.push(iframe);
        }
      });

      if (videoIframes.length) {
        videoIframes.forEach((iframe) => {
          // Wrap video
          const wrapperDiv = document.createElement("div");
          wrapperDiv.classList.add("videowrapper");
          iframe.parentNode.insertBefore(wrapperDiv, iframe);
          wrapperDiv.appendChild(iframe);

          // GET URL iFrame from $videoIframes
          const videoIframeSrc = iframe.getAttribute("src");

          // ADD attribute data-cookieconsent="marketing" to $videoIframes
          iframe.setAttribute("data-cookieconsent", "marketing");
          iframe.setAttribute("data-cookieblock-src", videoIframeSrc);

          // ADD element to #videowrapper
          const consentDiv = document.createElement("div");
          consentDiv.classList.add("cookieconsent-optout-marketing");
          const consentLink = document.createElement("a");
          consentLink.href = "javascript:Cookiebot.renew()";
          consentLink.textContent = "accept marketing-cookies";
          consentDiv.appendChild(document.createTextNode("Please "));
          consentDiv.appendChild(consentLink);
          consentDiv.appendChild(
            document.createTextNode(" to watch this video.")
          );
          wrapperDiv.appendChild(consentDiv);

          if (document.documentElement.lang === "fr-FR") {
            consentDiv.innerHTML =
              "Veuillez <a href='javascript:Cookiebot.renew()'>accepter les cookies marketing</a> pour regarder cette vidéo.";
          }

          if (window.Cookiebot && window.Cookiebot.consent) {
            if (window.Cookiebot.consent.marketing) {
              iframe.setAttribute("src", videoIframeSrc);
              iframe.classList.add("is-visible");
              iframe.style.display = "block";
              wrapperDiv.parentNode.classList.add("cookies-accepted");
            } else {
              iframe.setAttribute("src", "");
              wrapperDiv.parentNode.classList.remove("cookies-accepted");
            }

            window.addEventListener("CookiebotOnAccept", function (e) {
              // console.log("CookiebotOnAccept");
              if (window.Cookiebot.consent.marketing) {
                iframe.setAttribute("src", videoIframeSrc);
                iframe.classList.add("is-visible");
                iframe.style.display = "block";
                wrapperDiv.parentNode.classList.add("cookies-accepted");
              } else {
                iframe.setAttribute("src", "");
                wrapperDiv.parentNode.classList.remove("cookies-accepted");
              }
            });
          }
        });
      }

      /* Icon Accessibilité */
      $("#contrast").click(() => {
        $("body").toggleClass("accessibility-contrast-active");
      });
      $("#text-bigger").click(() => {
        $("html").css(
          "font-size",
          get_new_pixel_value($("html").css("font-size"), 1)
        );
      });
      $("#text-smaller").click(() => {
        $("html").css(
          "font-size",
          get_new_pixel_value($("html").css("font-size"), -1)
        );
      });
      const $r = new RegExp("^(?:[a-z]+:)?//", "i");
      $("a").each(function () {
        if (
          $r.test($(this).attr("href")) &&
          $(this)
            .attr("href")
            .replace("http://", "")
            .replace("https://", "")
            .replace("www.", "")
            .split(/[/?#]/)[0] !=
            window.location.origin
              .replace("http://", "")
              .replace("https://", "")
              .replace("www.", "")
              .split(/[/?#]/)[0] &&
          /\S/.test($(this).text())
        ) {
          $(this).append("<i class='dashicons dashicons-external'></i>");
        }
      });
      $(".make-me-external a").each(function () {
        $(this).append("<i class='dashicons dashicons-external'></i>");
      });

      $(".menu>li .nav-link").bind("keydown", function (event) {
        var keycode = window.event ? event.keyCode : e.keyCode;
        if (keycode == 9) {
          $(this).siblings(".sub-menu").addClass("focused");
        }
      });
      $(".sub-menu li:last-child .nav-link").bind("keydown", function (event) {
        var keycode = window.event ? event.keyCode : e.keyCode;
        if (keycode == 9) {
          $(this).parents(".sub-menu").removeClass("focused");
        }
      });
      $("*[tabindex], input, a, button").on("focus", function (e) {
        const $element = $(this);
        $(window).keyup((e) => {
          var code = e.keyCode ? e.keyCode : e.which;
          if (code == 9) {
            $("*").removeClass("is-focused");
            $element.addClass("is-focused");
          }
        });
      });

      const socialLinks = document
        .querySelector(".socials")
        .getElementsByTagName("a");
      if (socialLinks) {
        for (const link of socialLinks) {
          // if(link.classList.contains("fa-twitter")){
          //   <i class="fa-brands fa-x-twitter"></i>
          // }
          const title = link.getAttribute("title");
          link.setAttribute("aria-label", title);
        }
      }

      const langLinks = document.querySelectorAll(".wpml-ls-link");

      if (langLinks) {
        for (const link of langLinks) {
          const title = link
            .querySelector(".wpml-ls-native")
            .getAttribute("lang");
          if (title === "en") {
            link.setAttribute("aria-label", "English");
          } else {
            link.setAttribute("aria-label", "Français");
          }
        }
      }

      // CMP Cookiebot add renew link
      if (window.Cookiebot) {
        const lang = document.querySelector("html").lang;

        const navFooter =
          document.querySelector("#menu-navigation-footer") ||
          document.querySelector("#menu-navigation-footer-en");
        const li = document.createElement("li");
        li.classList.add(
          "menu-item",
          "menu-item-type-post_type",
          "menu-item-object-page"
        );

        const a = document.createElement("a");
        a.classList.add("nav-link");

        a.href = "javascript:Cookiebot.renew()";
        a.innerText =
          lang === "en-US"
            ? "Renew cookie consent"
            : "Renouveler le consentement aux cookies";
        li.appendChild(a);
        navFooter.appendChild(li);

        a.addEventListener("click", function (e) {
          e.preventDefault();
          window.Cookiebot.renew();
        });
      }
    });
    function get_new_pixel_value($pixels, increment) {
      const value = parseInt($pixels.slice(0, -1));
      if (Math.sign(increment) == 1 && value >= 24) {
        return "24px";
      } else if (Math.sign(increment) == -1 && value <= 16) {
        return "16px";
      }

      return `${value + increment}px`;
    }
  }

  initSliders() {
    this.sliders = [];
    for (var i = 0; i < this.sectionSlider.length; i++) {
      var slider = new SliderFlexible(this.sectionSlider[i]);
      this.sliders.push(slider);
    }
  }

  initVideos() {
    this.videos = [];
    for (var i = 0; i < this.sectionVideo.length; i++) {
      var video = new VideoFlexible(this.sectionVideo[i]);
      this.videos.push(video);
    }
  }

  initGrilleTarifs() {
    this.grilles = [];
    for (var i = 0; i < this.sectionGrilles.length; i++) {
      var grille = new GrilleTarifs(this.sectionGrilles[i]);
      this.grilles.push(grille);
    }
  }

  initTracking() {
    // Elements
    this.anchors = document.querySelectorAll(".page-title_container .anchor a");
    this.ctas = document.querySelectorAll('[data-tracking="cta"]');
    this.accordions = document.querySelectorAll('[data-tracking="accordion"]');
    this.offerCheckboxes = document.querySelectorAll(
      '.block-offer_content input[type="checkbox"]'
    );

    // Listeners
    for (let i = 0; i < this.anchors.length; i++) {
      this.anchors[i].addEventListener("click", this.trackingAnchorClick);
    }
    for (let i = 0; i < this.ctas.length; i++) {
      this.ctas[i].addEventListener("click", this.trackingCtaClick);
    }
    for (let i = 0; i < this.accordions.length; i++) {
      this.accordions[i].addEventListener("click", this.trackingAccordionClick);
    }
    for (let i = 0; i < this.offerCheckboxes.length; i++) {
      this.offerCheckboxes[i].addEventListener(
        "click",
        this.offerCheckboxClick
      );
    }
  }

  initScrollTracking() {
    window.addEventListener("scroll", () => {
      // Calculate the scroll percentage
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (window.scrollY / scrollHeight) * 100;

      // Define the percentages to trigger the dataLayer
      const percentages = [15, 25, 50, 75, 90];

      // Check if the current scroll percentage matches any predefined percentage
      for (const percent of percentages) {
        if (scrolled >= percent && !window[`percent_${percent}_triggered`]) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "scroll",
            percent_scrolled: `${percent}`,
          });
          window[`percent_${percent}_triggered`] = true; // Mark the percentage as triggered
        }
      }
    });

    const watch = document.querySelector("footer");
    const ob = new IntersectionObserver(
      (payload) => {
        if (payload[0].isIntersecting) {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: "scroll",
            percent_scrolled: "reached_footer",
          });
        }
      },
      {
        rootMargin: "0px 0px -25% 0px",
      }
    );
    ob.observe(watch);
  }

  trackingAnchorClick(e) {
    // Tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "menu",
      click_url: e.target.href, // lien cliqué
      click_text: e.target.innerText.trim(), // texte de l'ancre
      menu_type: "ancres",
    });
  }

  trackingCtaClick(e) {
    // Tracking
    window.dataLayer.push({
      event: "cta",
      click_url: e.currentTarget.href, // lien cliqué
      click_text: e.currentTarget.innerText.trim(), // texte du bouton
      internal: e.currentTarget.target == "_blank" ? false : true, // true si cta vers lien interne - i.e: contient www.artm.quebec
      cta_type: e.currentTarget.getAttribute("data-tracking-type"), // nom de la nouvelle composante, le plus normalisé possible. L'idée est de comprendre quel type de bloc est a l'origine du clic
    });
  }

  trackingAccordionClick(e) {
    // Tracking
    let isOpen = e.target.getAttribute("aria-expanded") == "true";
    if (!isOpen) {
      window.dataLayer = window.dataLayer || [];
      if (e.target.innerHTML.indexOf("?") > -1) {
        window.dataLayer.push({
          event: "faq",
          faq_title: e.target.innerText,
        });
      } else {
        window.dataLayer.push({
          event: "accordéon",
          accordeon_title: e.target.innerText,
        });
      }
    }
  }

  offerCheckboxClick(e) {
    for (let i = 0; i < this.offerCheckboxes.length; i++) {
      if (e.target !== this.offerCheckboxes[i]) {
        this.offerCheckboxes[i].checked = false;
      }
    }

    if (e.target.checked) {
      const elementTopFromDocument =
        e.target.parentElement.getBoundingClientRect().top + window.scrollY;
      const scrollPosition = elementTopFromDocument - 100;
      window.scroll({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}
